module.exports = __webpack_public_path__ + "static/4-a8ba1d1e28959a6eb5c819a45f8e3dab.png";